import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Importação do provedor de autenticação
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { NotificationProvider } from './contexts/NotificationContext';

// Pages
import LoginPage from './pages/login';
import UnauthorizedPage from './pages/unauthorized';
import HubPage from './pages/hub';
import ProjectPage from './pages/project';
import CompleteRegistrationPage from './pages/completeRegistration';
import UserManagementPage from './pages/admin/users';
import AdminActivityDashboardPage from './pages/admin/activityDashboard';
import GlobalActivityDashboardPage from './pages/admin/globalActivityDashboard';
import ForgotPasswordPage from './pages/forgotPassword';
import ResetPasswordPage from './pages/resetPassword';
import AcceptBoardInvitePage from './pages/acceptBoardInvite';

// Componente de rota protegida com notificações
import AuthenticatedLayout from './components/authenticatedLayout';

// Define o tema escuro da aplicação
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      default: '#0d1828',
      paper: '#162238',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* AuthProvider e ToastProvider para toda a app, NotificationProvider apenas para rotas autenticadas */}
      <AuthProvider>
        <ToastProvider>
          <Router>
            <Routes>
              {/* Rotas públicas - SEM NotificationProvider */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/unauthorized" element={<UnauthorizedPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/invite/board/:inviteCode" element={<AcceptBoardInvitePage />} />
              
              {/* Rotas protegidas - COM NotificationProvider */}
              <Route path="/hub" element={
                <AuthenticatedLayout>
                  <HubPage />
                </AuthenticatedLayout>
              } />
              <Route path="/project/:projectId" element={
                <AuthenticatedLayout>
                  <ProjectPage />
                </AuthenticatedLayout>
              } />
              
              {/* Rota para completar o registro */}
              <Route path="/complete-registration" element={
                <AuthenticatedLayout>
                  <CompleteRegistrationPage />
                </AuthenticatedLayout>
              } />
              
              {/* Rotas de administração */}
              <Route path="/admin/users" element={
                <AuthenticatedLayout>
                  <UserManagementPage />
                </AuthenticatedLayout>
              } />
              <Route path="/admin/activities" element={
                <AuthenticatedLayout>
                  <AdminActivityDashboardPage />
                </AuthenticatedLayout>
              } />
              <Route path="/admin/activities/dashboard" element={
                <AuthenticatedLayout>
                  <GlobalActivityDashboardPage />
                </AuthenticatedLayout>
              } />
              
              {/* Redirecionamento da rota raiz */}
              <Route path="/" element={<Navigate to="/hub" replace />} />
              
              {/* Rota 404 - redireciona para o hub */}
              <Route path="*" element={<Navigate to="/hub" replace />} />
            </Routes>
          </Router>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
